import { FloraButton, Flex } from '@grupoboticario/flora-react'

import { ACCELERATION_STEPPER_VARIANT } from '@/constants/accelerationStepper'

import * as S from './AccelerationForm.styles'
import type { AccelerationStepperVariant } from './AccelerationForm.types'

const VARIANTS_WITHOUT_PUBLISH = new Set<AccelerationStepperVariant>([ACCELERATION_STEPPER_VARIANT.VIEW])

interface StepActionsProps {
  variant?: AccelerationStepperVariant
  isLastStep: boolean
  canGoBack: boolean
  isStepValid: boolean
  canPublish: boolean
  isLoading?: boolean
  onBack: () => void
  onNext: () => void
  onPublish?: () => void
  onCancel: () => void
}

function shouldShowPublish(variant: AccelerationStepperVariant, hasOnPublish: boolean): boolean {
  if (VARIANTS_WITHOUT_PUBLISH.has(variant)) {
    return false
  }
  return hasOnPublish
}

function renderLastStepPrimaryButton(options: {
  showPublish: boolean
  isStepValid: boolean
  isLoading: boolean
  onPublish?: () => void
}) {
  const { showPublish, isStepValid, isLoading, onPublish } = options

  if (!showPublish) {
    return null
  }

  return (
    <FloraButton css={S.actionButtonCss} disabled={!isStepValid || isLoading} onClick={onPublish} type="button">
      {isLoading ? 'Publicando...' : 'Publicar acelerador'}
    </FloraButton>
  )
}

function renderNonLastPrimaryButton(options: { isStepValid: boolean; onNext: () => void }) {
  const { isStepValid, onNext } = options
  return (
    <FloraButton css={S.actionButtonCss} disabled={!isStepValid} onClick={onNext} type="button">
      Continuar
    </FloraButton>
  )
}

/**
 * Botões de ação do stepper de aceleradores.
 * Renderiza Cancelar, Voltar (condicional), Continuar ou Publicar.
 */
const StepActions = ({
  variant = ACCELERATION_STEPPER_VARIANT.CREATE,
  isLastStep,
  canGoBack,
  isStepValid,
  canPublish = true,
  isLoading = false,
  onBack,
  onNext,
  onPublish,
  onCancel
}: StepActionsProps) => {
  const showPublish = shouldShowPublish(variant, Boolean(onPublish))

  const primaryAction = isLastStep
    ? renderLastStepPrimaryButton({ showPublish, isStepValid: isStepValid && canPublish, isLoading, onPublish })
    : renderNonLastPrimaryButton({ isStepValid, onNext })

  return (
    <Flex css={{ marginTop: '$6' }} gap="$3" justify="flex-end">
      <FloraButton css={S.actionButtonCss} hierarchy="secondary" onClick={onCancel} type="button">
        Cancelar
      </FloraButton>

      {canGoBack && (
        <FloraButton css={S.actionButtonCss} hierarchy="secondary" onClick={onBack} type="button">
          Voltar
        </FloraButton>
      )}

      {primaryAction}
    </Flex>
  )
}

export default StepActions
